<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="22"
    height="19"
    viewBox="0 0 22 19"
  >
    <path
      class="svg-primary"
      d="M12.4,22.8H3.508a1.249,1.249,0,0,1-1.171-1.314V11.036A1.249,1.249,0,0,1,3.508,9.722H18.975a1.249,1.249,0,0,1,1.171,1.315v4.119a.609.609,0,0,0,.607.613.624.624,0,0,0,.607-.613V11.036a2.5,2.5,0,0,0-2.408-2.563H14.745V7.2A1.383,1.383,0,0,0,13.4,5.8H8.823A1.383,1.383,0,0,0,7.478,7.2V8.473H3.508A2.5,2.5,0,0,0,1.1,11.036v10.45A2.5,2.5,0,0,0,3.508,24.05h8.916a.609.609,0,0,0,.607-.613A.633.633,0,0,0,12.4,22.8ZM8.714,7.224c0-.088.065-.175.108-.175H13.4c.043,0,.108.066.108.175V8.473H8.714Z"
      transform="translate(-1.1 -5.8)"
    />
    <g transform="translate(11.779 9.248)">
      <path
        class="svg-primary"
        d="M10.334,10.579l2.2-1.818a.442.442,0,0,0-.258-.785L9.441,7.8a.446.446,0,0,1-.387-.28L8.011,4.857a.445.445,0,0,0-.828,0L6.14,7.514a.446.446,0,0,1-.387.28L2.9,7.966a.442.442,0,0,0-.258.785l2.2,1.807A.453.453,0,0,1,5,11.009l-.721,2.764a.443.443,0,0,0,.667.484l2.4-1.538a.422.422,0,0,1,.473,0l2.409,1.538a.443.443,0,0,0,.667-.484l-.721-2.753A.442.442,0,0,1,10.334,10.579Z"
        transform="translate(-2.481 -4.575)"
      />
    </g>
  </svg>
</template>

<script>
export default {};
</script>
